var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"termly-embed","data-id":"17954961-c516-4f9d-9bc5-caa0e163f6ff","data-type":"iframe"}})}
var staticRenderFns = []

export { render, staticRenderFns }